// extracted by mini-css-extract-plugin
export var circle = "DecorativeCircle-module--circle--2Uxor";
export var circleWrapper = "DecorativeCircle-module--circle-wrapper--1psar";